import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
// import { IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { getVouchers } from "../../apis/cart/apis";
import { useNavigate, useParams } from "react-router";
import { Avatar } from "@mui/material";

export default function VoucherListingScreen() {
  const navigate = useNavigate();
  //   const [searchParams] = useSearchParams();
  //   const offerId = searchParams.get("offer");
  const { id: offerId } = useParams();
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(0);

  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchText);
      setPage(0);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchText]);

  useEffect(() => {
    const fetchVouchers = async () => {
      try {
        setLoading(true);

        const response = await getVouchers(
          page + 1,
          rowsPerPage,
          debouncedSearch,
          offerId,
        );

        setVouchers(response.data.results);
        setCount(response.data.count);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchVouchers();
  }, [page, rowsPerPage, debouncedSearch, offerId]);

  const leftAlignedOptions = {
    filter: false,
    setCellHeaderProps: () => ({
      style: {
        textAlign: "left",
      },
    }),
    setCellProps: () => ({
      style: {
        textAlign: "left",
      },
    }),
  };

  const columns = [
    {
      name: "name",
      label: "Name",
      options: leftAlignedOptions,
    },
    {
      name: "code",
      label: "Code",
      options: leftAlignedOptions,
    },
    {
      name: "status",
      label: "Status",
      options: {
        ...leftAlignedOptions,
        customBodyRender: (value) => (
          <Chip
            label={value}
            color={value === "Active" ? "success" : "error"}
            size="small"
          />
        ),
      },
    },
    {
      name: "num_carts",
      label: "Num Carts",
      options: leftAlignedOptions,
    },
    {
      name: "num_orders",
      label: "Num Orders",
      options: leftAlignedOptions,
    },
    {
      name: "image",
      label: "Image",
      options: {
        ...leftAlignedOptions,
        sort: false,
        customBodyRender: (value) =>
          value ? (
            <Avatar
              alt="Voucher"
              variant="square"
              src={value}
              sx={{
                width: 100,
                height: 100,
                objectFit: "cover",
              }}
            />
          ) : (
            "-"
          ),
      },
    },
    {
      name: "date_created",
      label: "Date Created",
      options: {
        ...leftAlignedOptions,
        customBodyRender: (value) =>
          new Date(value).toLocaleString([], {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          }),
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        ...leftAlignedOptions,
        sort: false,
        customBodyRender: (value) => (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={0.5}
          >
            <Tooltip title="View">
              <IconButton
                color="primary"
                onClick={() =>
                  navigate(`/w86zjruk6q/vouchers/${value}`)
                }
              >
                <RemoveRedEyeIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Edit">
              <IconButton
                color="primary"
                onClick={() => navigate(`/w86zjruk6q/vouchers/${value}/edit`)}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
    },
  ];
  const options = {
    selectableRows: "none",
    responsive: "standard",
    elevation: 0,
    serverSide: true,

    count,

    page,

    rowsPerPage,

    rowsPerPageOptions: [10, 20, 100],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    sort: false,
    onSearchChange: (text) => {
      setSearchText(text || "");
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          setPage(tableState.page);
          break;

        case "changeRowsPerPage":
          setRowsPerPage(tableState.rowsPerPage);
          setPage(0);
          break;

        default:
          break;
      }
    },
  };

  return (
    <Box p={2}>
      <Box display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/w86zjruk6q/vouchers/create")}
        >
          Create Voucher
        </Button>
      </Box>

      {loading && (
        <Box mb={2}>
          <CircularProgress size={20} />
        </Box>
      )}

      <MUIDataTable
        title={"All Vouchers"}
        data={vouchers}
        columns={columns}
        options={options}
      />
    </Box>
  );
}
